import axios from "axios";
import store from '../store/store'

const baseUrl = "https://backend.youandyou.app";

// const baseUrl = "http://localhost";

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`
  }
});
const createProduct = async (payload) => {


  try {
    await api.post("/create_product", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    return true;
  } catch (err) {

    return false;
  }
};

const getProducts = async () => {
  try {
    let result = await api.get("/products", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const createMarketProduct = async (payload) => {

  try {
    await api.post(`/create_market_product`, {
      id: payload.id,
      name: payload.name,
      price: payload.price,
      profile_image: payload.profile_image,
      product_type: payload.product_type,
      desc: payload.desc,
    }, {

      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    return true;
  } catch (err) {

    return false;
  }
};

const getMarketProducts = async () => {
  try {
    let result = await api.get(`/market_products`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const getMarketProductById = async (market_product_id) => {
  try {
    let result = await api.get(`/market_product?id=${market_product_id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });

    if (result.status === 200) {

      return result.data;
    } else {
      return false;
    }
  } catch (err) {

    return false;
  }
};

const backofficeSignIn = async (user, password) => {



  try {
    let result = await api.post(`/bkfuser_login`, {
      "username": user,
      "email": "",
      "passwd": password,
      "invitation_code": ""

    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });



    if (result.status === 200) {
      if (result.data.status) {

        localStorage.setItem("accessToken", result.data.token);
        // let res = await getBackofficeUser()



        store.state.accessToken = result.data.token
        return result.data.token;

      } else {

        return false;
      }
    } else {
      return false;
    }
  } catch (err) {


    return false;
  }
};

const createBackofficeAccount = async (payload) => {

  try {
    let result = await api.post(`/bkfuser_register`, {
      id: `${Date.now()}`,
      display_name: payload.name,
      role: payload.role,
      username: payload.username,
      password: payload.password,
      agent_telegram: payload.agent_telegram,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });

    if (result.status === 200) {

      return true;
    } else {
      return false;
    }
  } catch (err) {

    return false;
  }
};

const deleteManyMarketProduct = async (market_product_ids) => {
  try {
    let result = await api.delete(`/delete_many_market_product`, {
      data: {
        id: market_product_ids,
      },
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });

    if (result.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};
const deleteOneMarketProduct = async (id) => {
  try {
    let result = await api.delete(`/delete_one_market_product`, {
      data: { id: id },
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });

    if (result.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};
const deleteManyProduct = async (product_ids) => {

  let query = { id: product_ids };
  try {
    let result = await api.delete(`/delete_many_product`, {
      data: query,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });

    if (result.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};
const deleteOneProduct = async (id) => {


  try {
    let result = await api.delete(`/delete_one_product`, {
      data: { id: id },
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });



    if (result.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};

const getAllCustomer = async () => {
  try {
    let result = await api.get("/get_all_customer", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const getBackofficeUser = async () => {

  try {
    let result = await api.get("/get_bkfuser", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      store.state.current_user = result.data.data
      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};


const getBackofficeUserList = async () => {


  try {
    let result = await api.get("/get_bkfusers", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {

      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const editBackOfficeUser = async (payload) => {

  let query = {
    id: payload.id,
    role: payload.role.id,
    suspended: payload.suspended,
    agent_telegram: payload.agent_telegram,
  };


  try {
    let result = await api.put("/edit_backoffice_user", query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return true;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const editMarketProduct = async (payload) => {

  let query = {
    id: payload.id,
    name: payload.name,
    price: payload.price,
    desc: payload.desc,
    profile_image: payload.profile_image,
    product_type: payload.product_type,
  };
  try {
    let result = await api.put("/edit_market_product", query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return true;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const getBackofficeUserById = async (id) => {
  try {
    let result = await api.get(`/get_bkfuser?id=${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const getProductById = async (id) => {
  try {
    let result = await api.get(`/product?id=${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {

      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const editProduct = async (payload) => {

  try {
    let result = await api.put("/edit_product", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return true;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const getAllBookingQueue = async () => {
  try {
    let result = await api.get(`/bookings`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {

      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const editBookingStatus = async (payload) => {

  let query = {
    id: payload.id,
    status: payload.status,
  };


  try {
    let result = await api.put("/edit_status_booking", query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return true;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const getBookingById = async (id) => {
  try {
    let result = await api.get(`/booking?id=${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {

      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const editCustomer = async (payload) => {
  let query = {
    username: payload.username,
    suspend: payload.suspend,
    tier: payload.tier,
  };

  try {
    let result = await api.put("/edit_customer", query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {
      return true;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

const changeBackofficeNamePassword = async (payload) => {

  // edit_bkf_name_password
  let query = {
    "id": payload.id,
    "display_name": payload.display_name,
    "password": payload.password,
    "agent_telegram": payload.agent_telegram
  };

  try {
    let result = await api.put("/edit_bkf_name_password", query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {

      return true;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
}


// get_booking_by_date

const getBookingByStartAndEnd = async (start, end) => {
  try {
    let result = await api.get(`/get_booking_by_date?dategt=${start}&datelt=${end}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (result.status === 200) {

      return result.data.data;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};

export {

  createProduct,
  createMarketProduct,
  getProducts,
  getMarketProducts,
  getMarketProductById,
  backofficeSignIn,
  createBackofficeAccount,
  deleteManyMarketProduct,
  deleteOneMarketProduct,
  deleteManyProduct,
  deleteOneProduct,
  getAllCustomer,
  getBackofficeUser,
  editBackOfficeUser,
  getBackofficeUserById,
  editMarketProduct,
  getProductById,
  editProduct,
  getAllBookingQueue,
  editBookingStatus,
  getBookingById,
  editCustomer,
  changeBackofficeNamePassword,
  getBackofficeUserList,

  getBookingByStartAndEnd
};
